import { useAuth } from '@app/core/auth/authentication/hooks';
import { ImpersonationPage } from '@app/core/auth/impersonation';
import { AppRoute } from '@app/core/routing/AppRoute';
import { NotificationPreferencesPage } from '@app/modules/notifications/preferences/NotificationPreferencesPage';
import { useOptionalNotificationsSessionContext } from '@app/modules/notifications/session/useNotificationsSessionContext';
import { Switch } from 'react-router-dom';
import { UserSettingsPage } from '../screens/user-settings/UserSettingsPage';

export function SettingsRoutes() {
  const { isSuperadmin, isImpersonated } = useAuth();
  const allowImpersonationRoute = isSuperadmin || isImpersonated;
  const notificationsSession = useOptionalNotificationsSessionContext();
  const showNotificationPreferences = notificationsSession?.isKnockReady === true;

  return (
    <Switch>
      {allowImpersonationRoute && (
        <AppRoute path={SettingsRoutes.ROUTES.impersonation} component={ImpersonationPage} />
      )}
      <AppRoute exact path="/settings/user" component={UserSettingsPage} />
      {showNotificationPreferences && (
        <AppRoute
          exact
          path={SettingsRoutes.ROUTES.notifications}
          component={NotificationPreferencesPage}
        />
      )}
    </Switch>
  );
}

SettingsRoutes.ROUTES = {
  impersonation: '/settings/impersonation',
  userSettings: '/settings/user',
  notifications: '/settings/notifications',
};
